import { User } from "oidc-client-ts";

let pendingSignin: Promise<User | null> | null = null;

export function signinSilentOnce(signinSilent: () => Promise<User | null>) {
  pendingSignin ??= signinSilent()
    .catch(() => null)
    .finally(() => {
      pendingSignin = null;
    });
  return pendingSignin;
}
